<template>
  <product-shipping-methods ref="shippingMethodsRef" data-test-id="pdp-shipping-methods" />
</template>

<script lang="ts" setup>
const shippingMethodsRef = ref()

defineExpose({
  method: computed(() => shippingMethodsRef.value?.method)
})
</script>
